/**
 * Shared disabled-reason affordance for the seed drawer's "Refresh" buttons
 * (DetailsTab + DomainHistoryTab).
 *
 * When the data refresh is blocked by seed STATUS (F/FR/D via
 * `isSeedRefreshable` — not merely a refresh in flight), the disabled button
 * is wrapped in a Tooltip + focusable span so the reason is keyboard reachable
 * and exposed to assistive tech — a bare `title` attribute is NOT announced on
 * a disabled button. Mirrors the HardDeleteTrigger / RetestButton precedent.
 *
 * @module sections/seeds/components/drawer/tabs
 */
import type { ReactElement } from 'react';

import { Tooltip } from '@/components/Tooltip';

/** Reason shown when the seed's status (F/FR/D) blocks the data refresh. */
export const REFRESH_BLOCKED_REASON =
  "This seed's status does not allow a data refresh";

export const withRefreshBlockedReason = (
  button: ReactElement,
  statusBlocked: boolean
): ReactElement =>
  statusBlocked ? (
    <Tooltip title={REFRESH_BLOCKED_REASON}>
      <span tabIndex={0} data-testid="seed-refresh-blocked">
        {button}
      </span>
    </Tooltip>
  ) : (
    button
  );
